<!-- desktop template -->
<div *appIsDesktop>
  @if (isMigratedQuote) {
    <div id="quoteMigratedNotificationMessage"
      class="quoteExpiredMessageContainer">
      {{appStrings.quote_migratedMessage}}
      <a id="checkForUpdatesMigratedQuoteLink" (click)="displayMigratedQuoteAction()">{{appStrings.clickHere_message}}</a>
      {{appStrings.quote_expiredMessageCheckForUpdates}}
    </div>
  }

  @if (priceMatrixChangedAfterMerge) {
    <div id="priceMatrixChangedAfterMergeNotificationMessage"
      class="quotePriceMatrixChangedMessageContainer">
      {{appStrings.quote_priceMatrixMessage}}
      <span id="linkUpdates">
        <a id="priceMatrixOrCurrencyLink"
        (click)="displayUpdatedPriceMatrixesAndCurrencies()">{{appStrings.clickHere_message}}</a>
        {{appStrings.quote_expiredMessageCheckForUpdates}}
      </span>
    </div>
  }

  @if (restoredQuote && !isExpiredQuote) {
    <div id="quoteRestoredNotificationMessage"
      class="quoteRestoredMessageContainer">
      <span class="crm-industrial-font icon-info"></span>{{quoteRestoredMessage}}
    </div>
  }

  @if (isExpiredQuote && !isMigratedQuote) {
    <div id="quoteExpiredNotificationMessage"
      class="quoteExpiredMessageContainer">
      <span class="crm-industrial-font icon-info"></span>
      {{appStrings.quote_expiredMessage}}
      <a id="checkForUpdatesLink" (click)="displayQuoteExpiredAction()">{{appStrings.clickHere_message}}</a>
      {{appStrings.quote_expiredMessageCheckForUpdates}}
    </div>
  }

  @if (!orderIsCompleted) {
    <div class="header-container">
      @if (lead || customer) {
        <ds-button id="goBackButton" size="medium" type="tertiary" variant="label-icon" id="backToDashboardButton" icon="keyboard_arrow_left"
          (onClick)="goBack()" [label]="appStrings.link_backToDashboard" iconStyle="material-icons-outlined">
        </ds-button>
      }
      @if (!lead && !customer) {
        <typography id="noCustomerSelectedTitle" variant="mat-headline-4" weight="bold"> {{ appStrings.quote_noCustomerSelected }}</typography>
      }
      @if (!importQuoteActive) {
        <div class="custom-header-buttons">
          <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeBtn" (onClick)="closeQuote()"
            [label]="appStrings.button_close">
          </ds-button>
          @if (canEdit && !quoteIsCompleted && !orderIsCompleted) {
            <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="deleteBtn" (onClick)="confirmDeleteQuote()" [isDisabled]="quoteSaveInProgress"
              [label]="appStrings.button_delete">
            </ds-button>
          }
          @if (!quoteIsCompleted && !orderIsCompleted) {
            <ds-button class="half-width" size="large" type="secondary" variant="label-only" id="saveAndCloseBtn" (onClick)="saveAndCloseQuote()" [isDisabled]="quoteSaveInProgress"
              [label]="quoteSaveInProgress ? appStrings.button_saving : appStrings.button_saveAndClose">
            </ds-button>
          }
          @if (!orderIsCompleted) {
            <ds-button class="buttons-container" size="large" type="primary" variant="label-only" id="completeQuoteBtn"
              [isDisabled]="quoteSaveInProgress || quoteIsCompleted || toolEditInProgress || updatingPriceMatrixAfterMergeButton"
              (onClick)="completeQuote()" [label]="appStrings.button_completeQuote">
            </ds-button>
          }
        </div>
      }
    </div>
    @if (isLoading || atpRefreshing) {
      <div id="loadingContainer" class="overlay full">
        @if (!atpRefreshing) {
          <p class="text-center">{{orderValidationInProgress ? appStrings.loading_orderIsProcessing :
            appStrings.pleaseWait}}
          </p>
        }
        @if (atpRefreshing) {
          <p class="text-center">{{appStrings.loading_refreshingAtpText}}</p>
        }
        @if (doNotRefresh) {
          <p class="error-text-strong">{{appStrings.payment_pleaseDoNotRefresh}}</p>
        }
        @if (isLoading || atpRefreshing) {
          <mat-spinner id="accountsLoader"></mat-spinner>
        }
      </div>
    }
    <div class="quote-info-container">
      @if (lead) {
        <div class="quote-title">
          <typography id="leadTitle" variant="mat-headline-4" weight="bold"> {{ lead.name }} - {{ lead.address }}</typography>
        </div>
      }
      @if (customer) {
        <div class="quote-title">
          <typography id="customerTitle" variant="mat-headline-4" weight="bold"> {{ customer.name }} - {{ customer.bpNumber }} - {{ customer.address }}</typography>
        </div>
      }
      <div class="quote-number">
        @if (quoteNumber) {
          <ds-chip id="quoteId" class="selectable-chip" variant="filled" size="medium">{{ appStrings.quoteDetails_quoteId }} {{ quoteNumber }}</ds-chip>
        }
        @if (isMigratedQuote) {
          <ds-chip id="migratedQuoteId" class="selectable-chip" variant="filled" size="medium">{{ appStrings.quote_migratedDialogTitle }} ID: {{ migratedQuote.migratedQuoteNumber }}</ds-chip>
        }
      </div>
    </div>
    <mat-accordion id="quoteContainer">
      <mat-expansion-panel id="quoteDetailsContainer" #quoteDetailsPanel>
        <mat-expansion-panel-header id="quoteDetailsSummary" class="content-header large-content-header" (click)="goToQuoteDetails($event)">
          <mat-panel-title id="quote-details-container" class="panel-header">
            <div class="title-column">
              <span id="quote-details-title" class="title">
                {{ appStrings.quote_detailsLabel}}
              </span>
            </div>
            <div class="divider">
              <ds-divider [vertical]="true"></ds-divider>
            </div>
            <div class="details-column">
              <ds-paper id="quoteDetailsCustomerName" class="large-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="quoteDetailsCustomerName_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryCustomer }}</typography>
                <typography id="quoteDetailsCustomerName_value" variant="mat-caption-1" weight="regular" class="secondary-text">{{ lead?.name || customer?.name || '-' }}</typography>
              </ds-paper>
              <ds-paper id="quoteDetailsQuoteName" class="large-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="quoteDetailsQuoteName_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryQuoteName }}</typography>
                <typography id="quoteDetailsQuoteName_value" variant="mat-caption-1" weight="regular" class="secondary-text">{{ summary.quoteDetails?.quoteName || '-' }}</typography>
              </ds-paper>
              <ds-paper id="quoteDetailsPriceMatrix" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="quoteDetailsPriceMatrix_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryPriceMatrix }}</typography>
                <typography id="quoteDetailsPriceMatrix_value" variant="mat-caption-1" weight="regular" class="secondary-text">{{ summary.quoteDetails?.priceMatrix?.priceList || '-' }}</typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quoteDetailsContent">
          <ds-divider></ds-divider>
          <app-quote-details (goToProductList)="goToProductList()"
            (displayQuoteIsExpired)="displayQuoteExpiredNotification($event)"
            (displayPriceMatrixChangedAfterMerge)="displayPriceMatrixChangedAfterMergeNotification($event)"
            (handleMigratedQuote)="handleMigratedQuote($event)"
            (hideInactiveChange)="hideInactiveCustomers = $event">
          </app-quote-details>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel class="permanent-details-header" id="quoteProductsContainer" #quoteProductsPanel>
        <mat-expansion-panel-header id="quoteProductsHeader" class="content-header large-content-header" (click)="goToProductList($event)" [ngClass]="{'warn': sectionErrors.products}">
          <mat-panel-title id="quote-products-container" class="panel-header">
            <div class="title-column">
              <span id="quote-products-title" class="title">
                {{ appStrings.quote_productGridLabel}}
              </span>
              @if (sectionErrors.products) {
                <ds-alert id="productsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none" class="header-alert">
                </ds-alert>
              }
            </div>
            <div class="divider">
              <ds-divider [vertical]="true"></ds-divider>
            </div>
            <div class="details-column">
              <ds-paper id="productGridToolsNumber" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="productGridToolsNumber_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryNumberOfTools }}</typography>
                <typography id="productGridToolsNumber_value" variant="mat-caption-1" weight="regular" class="secondary-text">{{ productCount }}</typography>
              </ds-paper>
              <ds-paper id="productGridErrorNumber" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="productGridErrorNumber_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryNumberOfErrors }}</typography>
                <typography id="productGridErrorNumber_value" variant="mat-caption-1" weight="regular" class="secondary-text">{{ errorCount }}</typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ds-divider></ds-divider>
        <div id="quoteProductsContent" class="relative">
          <app-product-grid (goToPaymentDetails)="goToPaymentDetails()" [errorCount]="errorCount" (goToOrderNotifications)="goToOrderNotifications()"
          [canEdit]="!quoteIsCompleted" [currencySymbol]="currencySign"></app-product-grid>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quoteNotificationContainer" #quoteNotificationPanel>
        <mat-expansion-panel-header id="quoteNotificationHeader" class="content-header large-content-header" (click)="goToOrderNotifications($event)" [ngClass]="{'warn': sectionErrors.notifications}">
          <mat-panel-title id="quote-notification-container" class="panel-header">
            <div class="title-column">
              <span id="quote-notification-title" class="title">
                {{ isLead ? appStrings.paymentDetails_ContactInfo : appStrings.quote_ens_title}}
              </span>
              @if (sectionErrors.notifications) {
                <ds-alert id="notificationsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none" class="header-alert">
                </ds-alert>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ds-divider></ds-divider>
        <div id="quoteNotificationContent">
          <app-quote-email-notification [accountManagerId]="accountManagerId" [customerId]="customer?.id" [isLead]="isLead" #quoteNotificationComp
            (goToPaymentDetails)="goToPaymentDetails()">
          </app-quote-email-notification>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quotePaymentContainer" #quotePaymentPanel>
        <mat-expansion-panel-header id="quotePaymentHeader" class="content-header large-content-header" (click)="goToPaymentDetails($event)" [ngClass]="{'warn': sectionErrors.payment}">
          <mat-panel-title id="quote-payment-container" class="panel-header">
            <div class="title-column">
              <span id="quote-payment-title" class="title">
                {{ appStrings.quote_paymentDetailsLabel}}
              </span>
              @if (sectionErrors.payment) {
                <ds-alert id="paymentSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none" class="header-alert">
                </ds-alert>
              }
            </div>
            <div class="divider">
              <ds-divider [vertical]="true"></ds-divider>
            </div>
            <div class="details-column">
              <ds-paper id="paymentDetailsSubtotal" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="paymentDetailsSubtotal_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summarySubTotal }}</typography>
                @if (!isLead && !hasTaxComputingError) {
                  <typography id="paymentDetailsSubtotal_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                    {{paymentSummary.subTotal || '0' | currency: currencySign}}
                  </typography>
                } @else {
                  <typography id="paymentDetailsSubtotal_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                    {{!paymentSummary.subTotal ? appStrings.notApplicable : paymentSummary.subTotal | currency: currencySign}}
                  </typography>
                }
              </ds-paper>
              <ds-paper id="paymentDetailsFreight" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="paymentDetailsFreight_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryFreight }}</typography>
                <typography id="paymentDetailsFreight_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                  {{ hasTaxComputingError ? appStrings.notApplicable : paymentSummary?.freightCost ?
                  (paymentSummary.freightCost | currency:currencySign): ('0' | currency: currencySign) }}
                </typography>
              </ds-paper>
              <ds-paper id="paymentDetailsTax" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="paymentDetailsTax_label" variant="mat-subtitle-2" weight="bold">{{ taxNaming }}:</typography>
                @if (!hasTaxComputingError) {
                  <typography id="paymentDetailsTax_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                    {{ paymentSummary.tax ? (paymentSummary.tax | currency: currencySign) :
                    ('0' | currency: currencySign) }}
                  </typography>
                } @else {
                  <typography id="paymentDetailsTax_value" variant="mat-caption-1" weight="regular" class="red">
                    {{appStrings.paymentDetails_unableToCalculateTax}}
                  </typography>
                }
              </ds-paper>
              <ds-paper id="paymentDetailsWeight" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="paymentDetailsWeight_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryTotalWeight }}</typography>
                <typography id="paymentDetailsWeight_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                  {{ !hasTaxComputingError ? paymentSummary.totalWeight : '0' | number : '1.2-2'}} {{weightSymbol}}
                </typography>
              </ds-paper>
              <ds-paper id="paymentDetailsGrandTotal" class="small-card dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_2XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography id="paymentDetailsGrandTotal_label" variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_summaryGrandTotal }}</typography>
                <typography id="paymentDetailsGrandTotal_value" variant="mat-caption-1" weight="regular" class="secondary-text">
                  {{ paymentSummary.grandTotal && hasTaxComputingError ? appStrings.notApplicable : paymentSummary.grandTotal ?
                  (paymentSummary.grandTotal | currency: currencySign)
                  : ('0' | currency: currencySign) }}
                </typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quotePaymentContent">
          <ds-divider></ds-divider>
          <app-payment-details [currencySymbol]="currencySign" (goToQuoteOptions)="goToQuoteOptions()"></app-payment-details>
          <div class="float-right payment-buttons">
            @if (quotePaymentComp?.paymentDetailsOutdated) {
              <ds-button class="buttons-container" size="medium" type="secondary" variant="label-only" id="updatePaymentDetails"
                [isDisabled]="quoteSaveInProgress || !quotePaymentComp?.canEdit || quotePaymentComp?.paymentDetailsInProgress"
                (onClick)="saveQuoteAndUpdatePaymentDetails()" [label]="appStrings.quote_saveAndUpdatePayment">
              </ds-button>
            }
            @if (canEdit && !quoteSaveInProgress) {
              <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" id="continueButton"
                (onClick)="goToQuoteOptions()" [isDisabled]="quotePaymentComp?.paymentDetailsInProgress">
              </ds-button>
            }
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quoteOptionsContainer" #quoteOptionsPanel>
        <mat-expansion-panel-header id="quoteOptionsHeader" class="content-header large-content-header" (click)="goToQuoteOptions($event)" [ngClass]="{'warn': sectionErrors.options}">
          <mat-panel-title id="quote-options-container" class="panel-header">
            <div class="title-column">
              <span id="quote-options-title" class="title">
                {{ appStrings.quote_quoteOptions }}
              </span>
              @if (sectionErrors.options) {
                <ds-alert id="optionsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none" class="header-alert">
                </ds-alert>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ds-divider></ds-divider>
        <div id="quoteOptionsContent">
          <app-quote-options #quoteOptionsComp [quoteId]="quoteId" [canEdit]="canEdit && !quoteIsCompleted"
            [countryCode]="customer?.lnCountryName || lead?.lnCountryName">
          </app-quote-options>
          <div class="float-right payment-buttons">
            <ds-button class="buttons-container" size="medium" type="primary" variant="label-only" id="completeQuoteBtn"
              [isDisabled]="quoteSaveInProgress || quoteIsCompleted || toolEditInProgress || updatingPriceMatrixAfterMergeButton"
              (onClick)="completeQuote()" [label]="appStrings.button_completeQuote">
            </ds-button>
            @if (!isLead && !quoteIsCompleted) {
              <ds-button id="completeOrderButton" size="medium" type="primary" variant="label-only"
                (onClick)="initiateCompleteOrder()" [label]="appStrings.button_completeOrder"
                [isDisabled]="noProducts || isExpiredQuote || quoteSaveInProgress || itemizeInProgress || isMigratedQuote || toolEditInProgress || electronAppOutOfSync || updatingPriceMatrixAfterMergeButton">
              </ds-button>
            }
            @if (quoteIsCompleted) {
              <ds-button id="orderAcknowledgmentButton" size="medium" type="secondary" variant="label-only"
                (onClick)="seeOrderAcknowledgment()" [label]="appStrings.button_orderAcknowledgment">
              </ds-button>
            }
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quoteHistoryContainer" #quoteHistoryPanel>
        <mat-expansion-panel-header id="quoteHistoryHeader" class="content-header large-content-header" (click)="goToQuoteHistory($event)">
          <mat-panel-title id="quote-notification-container" class="panel-header">
            <div class="title-column">
              <span id="quote-history-title" class="title">
                {{ appStrings.quote_quoteHistoryLabel}}
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ds-divider></ds-divider>
        <div id="quoteHistoryContent">
          <app-quote-versioning (saveQuote)="saveQuote($event)"
            [ensEmails]="versioningEnsEmails"
            [contacts]="versioningContacts"></app-quote-versioning>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  }
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile" [ngClass]="{'hidden': orderIsCompleted}">
  @if (isMigratedQuote) {
    <div id="quoteMigratedNotificationMessage" class="quoteExpiredMessageContainer width-auto">
      {{appStrings.quote_migratedMessage}}
      <a id="checkForUpdatesMigratedQuoteLink" (click)="displayMigratedQuoteAction()">{{appStrings.clickHere_message}}</a>
      {{appStrings.quote_expiredMessageCheckForUpdates}}
    </div>
  }
  @if (priceMatrixChangedAfterMerge) {
    <div id="priceMatrixChangedAfterMergeNotificationMessage" class="quotePriceMatrixChangedMessageContainer width-auto">
      {{appStrings.quote_priceMatrixMessage}}
      <span id="linkUpdates">
        <a id="priceMatrixOrCurrencyLink"
        (click)="displayUpdatedPriceMatrixesAndCurrencies()">{{appStrings.clickHere_message}}</a>
        {{appStrings.quote_expiredMessageCheckForUpdates}}
      </span>
    </div>
  }
  @if (isExpiredQuote && !isMigratedQuote) {
    <div id="quoteExpiredNotificationMessage" class="quoteExpiredMessageContainer width-auto">
      <span class="crm-industrial-font icon-info"></span>
      {{appStrings.quote_expiredMessage}}
      <a id="checkForUpdatesLink" (click)="displayQuoteExpiredAction()">{{appStrings.clickHere_message}}</a>
      {{appStrings.quote_expiredMessageCheckForUpdates}}
    </div>
  }
  @if (restoredQuote && !isExpiredQuote) {
    <div id="quoteRestoredNotificationMessage" class="quoteRestoredMessageContainer">
      <span class="crm-industrial-font icon-info"></span>{{quoteRestoredMessage}}
    </div>
  }


  @if (!orderIsCompleted) {
    <div>
      @if (isLoading || atpRefreshing) {
        <div class="overlay full" id="quote-mobile-loadingSpinner">
          @if (!atpRefreshing) {
            <p class="text-center">{{orderValidationInProgress ? appStrings.loading_orderIsProcessing :
              appStrings.pleaseWait}}
            </p>
          }
          @if (atpRefreshing) {
            <p class="text-center">{{appStrings.loading_refreshingAtpText}}</p>
          }
          @if (doNotRefresh) {
            <p class="error-text-strong">{{appStrings.payment_pleaseDoNotRefresh}}</p>
          }
          @if (isLoading || atpRefreshing) {
            <mat-spinner></mat-spinner>
          }
        </div>
      }
      @if (lead) {
        <div>
          <typography variant="mat-headline-4" weight="bold"> {{ lead.name }} - {{ lead.address }}</typography>
        </div>
      }
      @if (customer) {
        <div>
          <typography variant="mat-headline-4" weight="bold"> {{ customer.name }} - {{ customer.bpNumber }} - {{ customer.address }}</typography>
        </div>
      }
      @if (quoteNumber) {
        <div class="quote-number">
          <typography variant="mat-body-2" weight="regular">
            <span class="quote-label"> {{ appStrings.quoteDetails_quoteId }} </span> {{ quoteNumber }}
          </typography>
        </div>
      }
      @if (isMigratedQuote) {
        <div class="quote-number">
          <typography variant="mat-body-2" weight="regular">
            <span class="quote-label"> {{ appStrings.quote_migratedDialogTitle }} ID: </span> {{ migratedQuote.migratedQuoteNumber }}
          </typography>
        </div>
      }
      <div class="buttons-container">
        <ds-button class="quarter-width" size="medium" type="secondary" variant="label-only" id="closeBtn" (onClick)="closeQuote()"
          [label]="appStrings.button_close">
        </ds-button>
        @if (canEdit && !quoteIsCompleted) {
          <ds-button class="quarter-width" size="medium" type="secondary" variant="label-only" id="deleteBtn" (onClick)="confirmDeleteQuote()" [isDisabled]="quoteSaveInProgress"
            [label]="appStrings.button_delete">
          </ds-button>
        }
        @if (!quoteIsCompleted) {
          <ds-button class="half-width" size="medium" type="secondary" variant="label-only" id="saveAndCloseBtn" (onClick)="saveAndCloseQuote()" [isDisabled]="quoteSaveInProgress"
            [label]="quoteSaveInProgress ? appStrings.button_saving : appStrings.button_saveAndClose">
          </ds-button>
        }
      </div>
      <mat-expansion-panel id="quoteDetailsContainer" #quoteDetailsPanelMobile>
        <mat-expansion-panel-header id="quoteDetailsSummary" class="content-header" (click)="goToQuoteDetails($event)">
          <mat-panel-title id="quote-details-container" class="panel-header">
            <div class="title-row">
              <span id="quote-details-title" class="title">
                {{ appStrings.quote_detailsLabel}}
              </span>
            </div>
            <div class="details-row">
              <ds-paper id="quoteDetailsCustomerName"class="full-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryCustomer }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">{{ lead?.name || customer?.name || '-'}}</typography>
              </ds-paper>
              <ds-paper id="quoteDetailsQuoteName" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryQuoteName }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">{{ summary.quoteDetails?.quoteName || '-'}}</typography>
              </ds-paper>
              <ds-paper id="quoteDetailsPriceMatrix" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryPriceMatrix }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">{{ summary.quoteDetails?.priceMatrix?.priceList || '-'}}</typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quoteDetailsContent">
          <ds-divider></ds-divider>
          <app-quote-details (goToProductList)="goToProductList()"
            (displayQuoteIsExpired)="displayQuoteExpiredNotification($event)"
            (displayPriceMatrixChangedAfterMerge)="displayPriceMatrixChangedAfterMergeNotification($event)"
            (handleMigratedQuote)="handleMigratedQuote($event)"
            (hideInactiveChange)="hideInactiveCustomers = $event">
          </app-quote-details>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel class="permanent-details-header" id="quoteProductsContainer" #quoteProductsPanelMobile>
        <mat-expansion-panel-header id="quoteProductsHeader" class="content-header" (click)="goToProductList($event)"
          [ngClass]="{'warn': warnForErrors && errorCount}">
          <mat-panel-title id="quote-products-container" class="panel-header">
            <div class="title-row">
              <span id="quote-products-title" class="title">
                {{ appStrings.quote_productGridLabel}}
              </span>
              @if (sectionErrors.products) {
                <ds-alert id="productsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none">
                </ds-alert>
              }
            </div>
            <div class="details-row">
              <ds-paper id="toolsNumberContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryNumberOfTools }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">{{ productCount }}</typography>
              </ds-paper>
              <ds-paper id="errorsNumberContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryNumberOfErrors }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">{{ errorCount }}</typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quoteProductsContent" class="relative">
          <app-product-grid (goToPaymentDetails)="goToPaymentDetails()" (goToOrderNotifications)="goToOrderNotifications()" [errorCount]="errorCount"
          [canEdit]="!quoteIsCompleted" [currencySymbol]="currencySign"></app-product-grid>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quoteNotificationContainer" #quoteNotificationPanelMobile>
        <mat-expansion-panel-header id="quoteNotificationHeader" (click)="goToOrderNotifications($event)">
          <mat-panel-title id="quote-notification-container" class="panel-header">
            <div class="title-row">
              <span id="quote-notification-title" class="title">
                {{ isLead ? appStrings.paymentDetails_ContactInfo : appStrings.quote_ens_title}}
              </span>
              @if (sectionErrors.notifications) {
                <ds-alert id="notificationsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none">
                </ds-alert>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quoteNotificationContent">
          <ds-divider></ds-divider>
          <app-quote-email-notification [accountManagerId]="accountManagerId" [customerId]="customer?.id" [isLead]="isLead" #quoteNotificationComp
            (goToPaymentDetails)="goToPaymentDetails()">
          </app-quote-email-notification>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quotePaymentContainer" #quotePaymentPanelMobile>
        <mat-expansion-panel-header id="quotePaymentHeader" class="content-header" (click)="goToPaymentDetails($event)" [ngClass]="{'warn': sectionErrors.payment}">
          <mat-panel-title id="quote-payment-container" class="panel-header">
            <div class="title-row">
              <span id="quote-payment-title" class="title">
                {{ appStrings.quote_paymentDetailsLabel}}
              </span>
              @if (sectionErrors.payment) {
                <ds-alert id="paymentSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none">
                </ds-alert>
              }
            </div>
            <div class="details-row">
              <ds-paper id="subtotalContainer" class="full-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summarySubTotal }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">
                  @if (!isLead && !hasTaxComputingError) {
                    <span>{{paymentSummary.subTotal || '0' | currency: currencySign}} </span>
                  } @else {
                    <span>{{!paymentSummary.subTotal ? appStrings.notApplicable : paymentSummary.subTotal | currency: currencySign}}</span>
                  }
                </typography>
              </ds-paper>
              <ds-paper id="freightContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryFreight }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">
                  {{ hasTaxComputingError ? appStrings.notApplicable : paymentSummary?.freightCost ?
                  (paymentSummary.freightCost | currency:currencySign): ('0' | currency: currencySign) }}
                </typography>
              </ds-paper>
              <ds-paper id="taxContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ taxNaming }}:</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">
                  @if (!hasTaxComputingError) {
                    <span>
                      {{ paymentSummary.tax ? (paymentSummary.tax | currency: currencySign) :
                      ('0' | currency: currencySign) }}
                    </span>
                  } @else {
                    <span class="red">{{appStrings.paymentDetails_unableToCalculateTax}}</span>
                  }
                </typography>
              </ds-paper>
              <ds-paper id="weightContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryTotalWeight }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">
                  {{ !hasTaxComputingError ? paymentSummary.totalWeight : '0' | number : '1.2-2'}} {{weightSymbol}}
                </typography>
              </ds-paper>
              <ds-paper id="grandTotalContainer" class="half-width-paper dark-paper dark-border" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
                insidePaddingTop="top-spacing_3XS" insidePaddingBottom="bottom-spacing_3XS"
                insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
                <typography variant="mat-body-2" weight="bold">{{ appStrings.quote_summaryGrandTotal }}</typography>
                <typography variant="mat-body-2" weight="regular" class="secondary-text">
                  {{ paymentSummary.grandTotal && hasTaxComputingError ? appStrings.notApplicable : paymentSummary.grandTotal ?
                  (paymentSummary.grandTotal | currency: currencySign)
                  : ('0' | currency: currencySign) }}
                </typography>
              </ds-paper>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quotePaymentContent">
          <ds-divider></ds-divider>
          <app-payment-details [currencySymbol]="currencySign" (goToQuoteOptions)="goToQuoteOptions()"></app-payment-details>
          <div class="padded-bottom payment-buttons float-right">
            @if (quotePaymentComp?.paymentDetailsOutdated) {
              <ds-button class="buttons-container" size="medium" type="secondary" variant="label-only" id="updatePaymentDetails"
                [isDisabled]="quoteSaveInProgress || !quotePaymentComp?.canEdit || quotePaymentComp?.paymentDetailsInProgress"
                (onClick)="saveQuoteAndUpdatePaymentDetails()" [label]="appStrings.quote_saveAndUpdatePayment">
              </ds-button>
            }
            @if (canEdit && !quoteSaveInProgress) {
              <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" id="continueButtonMobile"
                (onClick)="goToQuoteOptions()" [isDisabled]="quotePaymentComp?.paymentDetailsInProgress">
              </ds-button>
            }
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel id="quoteOptionsContainer" #quoteOptionsPanelMobile>
        <mat-expansion-panel-header id="quoteOptionsHeader" (click)="goToQuoteOptions($event)">
          <mat-panel-title id="quote-options-container" class="panel-header">
            <div class="title-row">
              <span id="quote-options-title" class="title">
                {{ appStrings.quote_quoteOptions }}
              </span>
              @if (sectionErrors.options) {
                <ds-alert id="optionsSectionError" alert_type="error" [alert_message]="appStrings.quote_fixErrorsInSection" alert_action_type="none">
                </ds-alert>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="quoteOptionsContent">
          <ds-divider></ds-divider>
          <app-quote-options #quoteOptionsComp [quoteId]="quoteId" [canEdit]="canEdit && !quoteIsCompleted"
            [countryCode]="customer?.lnCountryName || lead?.lnCountryName">
          </app-quote-options>
          <div class="padded-bottom">
            @if (!isLead && !quoteIsCompleted) {
              <ds-button class="buttons-container" size="medium" type="primary" variant="label-only" id="completeOrderBtn"
                [isDisabled]="noProducts || isExpiredQuote || quoteSaveInProgress || itemizeInProgress || isMigratedQuote || toolEditInProgress || updatingPriceMatrixAfterMergeButton"
                (onClick)="initiateCompleteOrder()" [label]="appStrings.button_completeOrder">
              </ds-button>
            }
            @if (quoteIsCompleted) {
              <ds-button class="buttons-container" size="medium" type="primary" variant="label-only" id="orderAcknowledgmentBtn"
                (onClick)="seeOrderAcknowledgment()" [label]="appStrings.button_orderAcknowledgment">
              </ds-button>
            }
          </div>
        </div>
      </mat-expansion-panel>
      @if (!quoteIsCompleted) {
        <div class="mobile-sticky-footer">
          <ds-button class="buttons-container" size="medium" type="primary" variant="label-only" id="completeQuoteBtn"
            [isDisabled]="quoteSaveInProgress || quoteIsCompleted || toolEditInProgress || updatingPriceMatrixAfterMergeButton"
            (onClick)="completeQuote()" [label]="appStrings.button_completeQuote">
          </ds-button>
        </div>
      }
    </div>
  }
</div>

@if (orderIsCompleted) {
  <div class="order-completed-buttons">
    <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeBtn" (onClick)="closeQuote()"
      [label]="appStrings.button_close">
    </ds-button>
  </div>
  <app-order-completed id="orderCompleted" [orderConfirmationNumber]="orderConfirmationNumber"
    [quoteRevisionId]="quoteRevisionId"
    [ensEmails]="orderEnsEmails"
    [contacts]="orderContacts">
  </app-order-completed>
}

<ds-dialog
  [title]="dialogTitle"
  [description]="dialogText"
  [actionButtons]="dialogButtons"
  [open]="dialogOpen$">
</ds-dialog>